module.exports = __webpack_public_path__ + "img/std_bit.prt.5bbfb1d8.jpg";